/**
 * The stories zone on a public influencer profile.
 *
 * TWO CAROUSELS, NESTED. The outer one chooses which story is shown and takes the circular bubbles
 * as its dots; the inner one steps through that story's images with the arrows under the frame.
 * Both are carousel.js, which already owns index state, aria-hidden per slide, aria-current per dot
 * and the prev/next wiring.
 *
 * THE OUTER ONE OPTS OUT OF GESTURES. Bubbles are a list of choices, and a left arrow inside a
 * gallery would otherwise step the image and then bubble up and change the story as well. The
 * gallery inside keeps both arrow keys and swipe, which is where a visitor expects them.
 *
 * There is no counter wiring here: the position sits inside each image in the markup, so the only
 * one on screen is always the right one — with no script at all. The one thing this file does say
 * about state is the arrows: carousel.js clamps rather than wrapping, so at either end of a gallery
 * one of them genuinely has nothing to do, and a live-looking control that ignores the click is
 * worse than a disabled one.
 */

import { createCarousel } from "./carousel.js";

const ZONE_SELECTOR = ".js-member-stories";

const setUpZone = (zone) => {
  // One carousel per gallery, rooted on the gallery itself so its arrows resolve inside that story
  // rather than across all of them.
  zone.querySelectorAll(".js-member-stories__gallery").forEach((gallery) => {
    const previous = gallery.querySelector(".js-member-stories__image-prev");
    const next = gallery.querySelector(".js-member-stories__image-next");

    const paintEnds = (index, count) => {
      if (previous) {
        previous.disabled = index === 0;
      }

      if (next) {
        next.disabled = index === count - 1;
      }
    };

    const images = createCarousel(gallery, {
      slideSelector: ".js-member-stories__image",
      prevSelector: ".js-member-stories__image-prev",
      nextSelector: ".js-member-stories__image-next",
      interactiveClass: "is-interactive",
      onEnter: (_slide, index) => paintEnds(index, images.count),
    });

    if (images) {
      paintEnds(images.index, images.count);
    }
  });

  createCarousel(zone, {
    slideSelector: ".js-member-stories__pane",
    dotSelector: ".js-member-stories__bubble",
    interactiveClass: "is-interactive",
    gestures: false,
  });
};

export default function initMemberProfileStories() {
  document.querySelectorAll(ZONE_SELECTOR).forEach(setUpZone);
}
